import { z } from 'zod';
// Input DTO schema
export const GetUserCompaniesInputDTOSchema = z.object({
    userId: z.string().uuid(),
});
// Request and response schemas for API layer
export const GetUserCompaniesRequestDTOSchema = z.object({});
//# sourceMappingURL=get-user-companies.dto.js.map